/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import Button from 'newComponents/Button';
import './styles.scss';
import { useSelector } from 'react-redux';
import { getApaMetadataLite } from 'services/api/apa/metadata';
import { converter } from 'helpers/converter';

const selectTranslations = store => store.translations;

const TermsAndConditions = ({ onClick, apaKey = 'tyc_full_text' }) => {
  const translationsInStore = useSelector(selectTranslations);
  const [translations, setTranslations] = useState(null);
  const backButtonKey = translationsInStore.btn_menu_back;
  const getDisclaimerData = () => ({
    __html: converter.convertApaUnicode(translations, apaKey, ''),
  });

  const getTranslations = async () => {
    const metadataTranslations = await getApaMetadataLite();
    setTranslations(metadataTranslations);
  };

  useEffect(() => {
    getTranslations();
  }, []);

  return (
    <div className="TermsAndConditions">
      <div className="TermsAndConditions__Container">
        <div className="TermsAndConditions__Text">
          <div dangerouslySetInnerHTML={getDisclaimerData()} />
        </div>
        <div className="TermsAndConditions__Blur" />
        <div className="TermsAndConditions__Button_Container">
          <Button color="red" onClick={onClick}>
            <span style={{ fontWeight: 'bold', textTransform: 'uppercase' }}>
              {backButtonKey}
            </span>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
